import { render, staticRenderFns } from "./last.vue?vue&type=template&id=3d9ed150&scoped=true"
import script from "./last.vue?vue&type=script&lang=js"
export * from "./last.vue?vue&type=script&lang=js"
import style0 from "./last.vue?vue&type=style&index=0&id=3d9ed150&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_5a3c64a85473ede7d9205802ebc6db0e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9ed150",
  null
  
)

export default component.exports